import login from './login'
import save from './save'

export default {
  ...login,
  ...save
}
